module.exports = __webpack_public_path__ + "static/img/student.5709d24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/student.png
// module id = FUdP
// module chunks = 0